import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class VersionCheckService {
  private currentVersion = localStorage.getItem('appVersion');

  constructor(private http: HttpClient) { }

  public initVersionCheck(intervalMs = 60000) {
    this.checkVersion(); 
    setInterval(() => this.checkVersion(), intervalMs);
  }

  private checkVersion() {
    this.http.get<{ version: string }>(`/assets/version.json?cb=${Date.now()}`)
      .subscribe(res => {
        if (!this.currentVersion) {
          localStorage.setItem('appVersion', res.version);
          this.currentVersion = res.version;
        } else if (res.version !== this.currentVersion) {
          console.warn(`New UI version detected: ${res.version} (was ${this.currentVersion})`);
          localStorage.setItem('appVersion', res.version);
          window.location.replace(window.location.href);
        }
      });
  }
}